import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = (theme) => ({
  root: {
    display: 'flex',
    columnGap: theme.spacing(3),
  },
});

const Section = ({
  className,
  classes,
  children,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {children}
    </Box>
  );
};

Section.defaultProps = {
  className: '',
  children: null,
};

Section.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default withStyles(styles)(Section);
